// Load banned words data - loaded once and cached
let bannedWordsData = { bannedWords: [] };
let isLoading = false;
let isLoaded = false;

// Initialize banned words data
const initializeBannedWords = async () => {
    if (isLoading || isLoaded) return;
    
    isLoading = true;
    try {
        // For Next.js, fetch from public folder
        if (typeof window !== 'undefined') {
            const response = await fetch('/bannedWords.json');
            if (response.ok) {
                bannedWordsData = await response.json();
                isLoaded = true;
            }
        } else {
            // Server-side: use require for Node.js
            try {
                bannedWordsData = require('../../public/bannedWords.json');
                isLoaded = true;
            } catch (e) {
                console.warn('Could not load bannedWords.json on server:', e);
            }
        }
    } catch (error) {
        console.error('Error loading banned words:', error);
    } finally {
        isLoading = false;
    }
};

// Initialize on module load (client-side only)
if (typeof window !== 'undefined') {
    initializeBannedWords();
}

/**
 * Check if a message contains any banned words
 * @param {string} message - The message text to check
 * @returns {Object} - { hasBannedWords: boolean, bannedWords: string[] }
 */
export const checkBannedWords = (message) => {
    if (!message || typeof message !== 'string') {
        return { hasBannedWords: false, bannedWords: [] };
    }

    const bannedWords = bannedWordsData.bannedWords || [];
    
    // If not loaded yet and we're on client, try to load synchronously (this will queue)
    if (bannedWords.length === 0 && typeof window !== 'undefined' && !isLoaded && !isLoading) {
        initializeBannedWords();
        // For now, return false if data isn't loaded yet (fail open)
        // In production, you might want to queue the validation
        return { hasBannedWords: false, bannedWords: [] };
    }

    const messageLower = message.toLowerCase().trim();
    
    // Check for banned words in the message
    const foundBannedWords = [];
    
    bannedWords.forEach(bannedWord => {
        // Create a regex pattern that matches the banned word as a whole word
        // Using word boundaries and case-insensitive matching
        const regex = new RegExp(`\\b${bannedWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        
        if (regex.test(messageLower)) {
            foundBannedWords.push(bannedWord);
        }
    });

    return {
        hasBannedWords: foundBannedWords.length > 0,
        bannedWords: foundBannedWords
    };
};

/**
 * Validate message and return error message if banned words are found
 * @param {string} message - The message text to validate
 * @returns {string|null} - Error message if banned words found, null otherwise
 */
export const validateMessage = (message) => {
    const { hasBannedWords } = checkBannedWords(message);
    
    if (hasBannedWords) {
        return `Your message contains inappropriate language. Please remove offensive words and try again.`;
    }
    
    return null;
};

export default checkBannedWords;



